import React, { PureComponent } from 'react';
import { withRouter } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { PortalConfigContext, getConfig } from '../../config/portal';
import { geti18nLocations, getCurrentLocale, htmlLanguage, hrefLangs } from '../../utils/language';
import * as utils from '../../store/utils';

class SiteMeta extends PureComponent {
  render() {
    const cdnUrl = get(this.context, 'client.cdn.endpoint');
    const addKrux = get(this.context, 'supports.krux');
    const language = getCurrentLocale();
    const gtmContainer = get(this.context, 'scripts.gtm.container');
    const gtmParams = get(this.context, 'scripts.gtm.params', '');
    const kruxId = get(this.context, 'scripts.kruxId', '');
    const digitalDataBuilder = get(this.context, 'scripts.digitalDataBuilder', '');
    const DEFAULT_LANGUAGE_CODE = getConfig().language;
    let localizedLocation;
    if (!utils.isServer()) {
      localizedLocation = geti18nLocations(window.location.pathname, true);
    } else {
      localizedLocation = geti18nLocations(!this.props.location.pathname.endsWith('/') ? this.props.location.pathname + '/' : this.props.location.pathname, true);
    }
    return <Helmet>
      <html lang={htmlLanguage[language] || language} />
      <meta charset="utf-8" />
      <link rel="shortcut icon" href={`${cdnUrl}/assets/favicon.ico`} />
      <link rel="preload" as="style" href="https://fonts.googleapis.com/css?family=Lato:400,700,900&display=swap" />
      <link rel="stylesheet" type="text/css" href={`${cdnUrl}/assets/css/portal.css`}></link>
      <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no"></meta>
      <meta name="theme-color" content="#000000"></meta>
      {/*
      manifest.json provides metadata used when your web app is added to the
      homescreen on Android. See https://developers.google.com/web/fundamentals/web-app-manifest/
      */}
      <link rel="manifest" href={`${cdnUrl}/assets/manifest.webmanifest`}></link>
      <script>{`
          var dataLayer = [];
          (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});
            var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';
            j.async=true;
            j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl+'${gtmParams}';
            f.parentNode.insertBefore(j,f);
          })(window,document,'script','dataLayer','${gtmContainer}');`}</script>
      { addKrux &&
          <script className="kxint" data-namespace="boatsgroup" type="text/javascript">{`
            window.Krux||((Krux=function(){Krux.q.push(arguments);}).q=[]);
            (function(){
                function retrieve(n){
                    var k= 'kx'+'boatsgroup_'+n, ls=(function(){
                        try {
                            return window.localStorage;
                        } catch(e) {
                            return null;
                        }
                    })();
                    if (ls) {
                        return ls[k] || '';
                    } else if (navigator.cookieEnabled) {
                        var m = document.cookie.match(k+'=([^;]*)');
                        return (m && unescape(m[1])) || '';
                    } else {
                        return '';
                    }
                }
                Krux.user = retrieve('user');
                Krux.segments = retrieve('segs') ? retrieve('segs').split(',') : [];
            })();
          `}</script>
      }
      { addKrux &&
          <script className="kxct" data-id={`${kruxId}`} data-timing="async" data-version="3.0" type="text/javascript">{`
            window.Krux||((Krux=function() {Krux.q.push(arguments)}).q=[]);
            (function()  {
                var k=document.createElement('script');k.type='text/javascript';k.async=true;
                k.src=(location.protocol==='https:'?'https:':'http:')+'//cdn.krxd.net/controltag?confid=${kruxId}';
                var s=document.getElementsByTagName('script')[0];s.parentNode.insertBefore(k,s);
            }());

            // Krux event tracking, email submission
            var kruxEmail = function(){
                window.Krux||((Krux=function(){Krux.q.push(arguments);}).q=[]);
                Krux('ns:boatsgroup','admEvent', 'Lr5PmlEv', {});
            }
            // Krux event tracking, Click to reveal/call
            var kruxCall =  function() {
                window.Krux || ((Krux = function () {
                    Krux.q.push(arguments);
                }).q = []);
                Krux('ns:boatsgroup', 'admEvent', 'Lyt48KWG', {});
            }
          `}</script>
      }
      { addKrux &&
          <script>{`
            var setDMPConsent = function(consent) {
              window.Krux||((Krux=function(){Krux.q.push(arguments);}).q=[]);
              Krux('ns:boatsgroup', 'consent:set', {dc: consent,al: consent,tg: consent,cd: 0, sh: 0, re: 0 });
            };

            var consentCookie = document.cookie.match('cookieControl=([^;]*)');
            if(consentCookie) {
              var consent = (document.cookie.match('cookieControl=([^;]*)')[1]);
              if(consent === 'true') {
                setDMPConsent(true);
              } else {
                setDMPConsent(false);
              }
            } else {
              setDMPConsent(true);
            }
          `}
          </script>
      }
      { utils.isServer() && <noscript>
        {`<iframe src="https://www.googletagmanager.com/ns.html?id=${gtmContainer}${gtmParams}"
        height="0" width="0" style="display:none;visibility:hidden"></iframe>`}
      </noscript>  }
      <script type="text/javascript" src={digitalDataBuilder}></script>
      { localizedLocation && localizedLocation.map((lang, key) => {
        let langTag = lang.lang === DEFAULT_LANGUAGE_CODE ? 'x-default' : hrefLangs[lang.lang];

        return (
          <link key={key} rel="alternate" hrefLang={langTag} href={lang.route} />
        );
      })}
    </Helmet>;
  }
}

SiteMeta.contextType = PortalConfigContext;

SiteMeta.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string
  })
};

export default withRouter(SiteMeta);
